"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.prodFrontendUrl = exports.defaultEnvironment = exports.companyContractPremiumCodes = exports.companyContractCodes = void 0;
var TEndPoints = /*#__PURE__*/function (TEndPoints) {
  TEndPoints["V1"] = "v1";
  TEndPoints["V2"] = "v2";
  TEndPoints["V3"] = "v3";
  TEndPoints["V4"] = "v4";
  TEndPoints["V5"] = "v5";
  TEndPoints["V6"] = "v6";
  return TEndPoints;
}(TEndPoints || {});
const prodFrontendUrl = exports.prodFrontendUrl = 'https://geovelo.app';
const companyContractPremiumCodes = exports.companyContractPremiumCodes = ['geovelo-entreprise-standard', 'geovelo-entreprise-premium'];
const companyContractCodes = exports.companyContractCodes = [...companyContractPremiumCodes, 'geovelo-entreprise-free', 'geovelo-entreprise-holding'];
let environment = {
  frontendUrl: 'https://dev.geovelo.app',
  backendUrl: 'https://backend-dev.geovelo.fr',
  enterpriseUrl: 'https://app-dev.geovelo-entreprise.com/',
  enterpriseShowcaseUrl: 'https://geovelo-entreprise.com/',
  eventsSiteUrl: 'https://challenges-dev.geovelo.app/',
  tileServer: {
    url: 'https://tileserver-dev.geovelo.fr',
    styleDirs: {
      base: 'base-no-label-v2-2-vector',
      labels: 'labels-v2-vector',
      dark: 'base_dark_style-no-label-vector',
      darkLabels: 'label-dark-style-vector',
      facilities: 'facilities_v2-vector',
      facilitiesIDFM: 'facilities-style-idfm-vector'
    }
  },
  defaultApiVersion: 2,
  apiVersions: {
    v1: 1,
    v3: 3,
    v4: 4,
    v5: 5,
    v6: 6
  },
  apiKey: '',
  source: '',
  mapillaryAccessToken: 'MLY|3620358691401240|8cc0f2ca4b24b2a9ab3d5cffdba027e9',
  lav: {
    backendUrl: 'https://loire-a-velo-search.apsulis.ninja',
    imagesUrl: 'https://loireavelo.fr',
    apiKey: 'Bearer 48b83dfad4a6aaf00e84e2cbde6bf4894edf4592085141326693b6d29aa00f34'
  },
  bikeAllowanceUrl: 'https://indemnitevelo-dev.geovelo.fr',
  faqUrl: 'https://faq.geovelo.app',
  firebase: {
    apiKey: 'AIzaSyBhqyOfGFxeOi76Bw5SA3dJTaGFPTm5IBI',
    dynamicLinksDomainUriPrefix: 'https://link.geovelo.fr'
  },
  osm: {
    apiUrl: 'https://master.apis.dev.openstreetmap.org'
  },
  android: {
    bundleId: 'fr.geovelo',
    storeUrls: {
      fr: 'https://play.google.com/store/apps/details?id=fr.geovelo&gl=FR',
      en: 'https://play.google.com/store/apps/details?id=fr.geovelo&gl=US',
      de: 'https://play.google.com/store/apps/details?id=fr.geovelo&gl=DE',
      es: 'https://play.google.com/store/apps/details?id=fr.geovelo&gl=ES'
    }
  },
  ios: {
    bundleId: 'fr.lcdm.geovelo',
    storeUrls: {
      fr: 'https://apps.apple.com/fr/app/geovelo-bike-gps/id1261357713?itsct=apps_box_badge',
      en: 'https://apps.apple.com/us/app/geovelo-bike-gps/id1261357713?itsct=apps_box_badge',
      de: 'https://apps.apple.com/de/app/geovelo-bike-gps/id1261357713?itsct=apps_box_badge',
      es: 'https://apps.apple.com/es/app/geovelo-bike-gps/id1261357713?itsct=apps_box_badge'
    }
  },
  enableTmpFacilities: false,
  widgetDefaultApiKey: '1d4105cf-3fde-4373-829b-2804a95aafb1',
  savedKgOfCO2PerKilometer: 0.2176,
  enableSimplifyCrossingInstructions: true,
  stripeApiKey: 'rk_test_51FKhRAFZhSKilCuSjv4Xdc1ylCy1g0LNtqeOmSnqsSqGgjpaMwyTySmPH28608uLSKfdnPl2lrqqGw2jJ8Zy1kK300UVgGjh1F',
  wahoo: {
    clientId: 'owPFUYx6SqmNctdTDxw3PBjl_LN3Z5PneeMlrtFb-ss'
  },
  freeOfferCustomChallengesMaxDaysCount: 7,
  freeOfferSubgroupsLeaderboardsMaxRowsCount: 0,
  freeOfferEmployeesLeaderboardsMaxRowsCount: 10
};
if (process.env.REACT_APP_ENV === 'staging' || process.env.GATSBY_APP_ENV === 'staging') {
  environment = {
    ...environment,
    frontendUrl: 'https://staging.geovelo.app',
    backendUrl: 'https://backend-staging.geovelo.fr',
    enterpriseUrl: 'https://app-staging.geovelo-entreprise.com/',
    eventsSiteUrl: 'https://challenges-staging.geovelo.app/',
    tileServer: {
      url: 'https://tileserver.geovelo.fr',
      styleDirs: {
        base: 'base-no-label-v2-2-vector',
        labels: 'labels-v2-vector',
        dark: 'base_dark_style-no-label-vector',
        darkLabels: 'label-dark-style-vector',
        facilities: 'facilities_v2-vector',
        facilitiesIDFM: 'facilities-style-idfm-vector'
      }
    },
    osm: {
      apiUrl: 'https://api.openstreetmap.org'
    },
    lav: {
      backendUrl: 'https://api-search.preprod.loireavelo.com',
      imagesUrl: 'https://preprod.loireavelo.com',
      apiKey: 'Bearer 48b83dfad4a6aaf00e84e2cbde6bf4894edf4592085141326693b6d29aa00f34'
    },
    enableSimplifyCrossingInstructions: false,
    stripeApiKey: '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',
    wahoo: {
      clientId: ''
    }
  };
}
if (process.env.REACT_APP_ENV === 'production' || process.env.GATSBY_APP_ENV === 'production') {
  environment = {
    ...environment,
    frontendUrl: 'https://geovelo.app',
    backendUrl: 'https://backend.geovelo.fr',
    enterpriseUrl: 'https://app.geovelo-entreprise.com/',
    eventsSiteUrl: 'https://challenges.geovelo.app/',
    tileServer: {
      url: 'https://tileserver.geovelo.fr',
      styleDirs: {
        base: 'base-no-label-v2-2-vector',
        labels: 'labels-v2-vector',
        dark: 'base_dark_style-no-label-vector',
        darkLabels: 'label-dark-style-vector',
        facilities: 'facilities_v2-vector',
        facilitiesIDFM: 'facilities-style-idfm-vector'
      }
    },
    lav: {
      backendUrl: 'https://api-search.loireavelo.fr',
      imagesUrl: 'https://loireavelo.fr',
      apiKey: 'Bearer 48b83dfad4a6aaf00e84e2cbde6bf4894edf4592085141326693b6d29aa00f34'
    },
    osm: {
      apiUrl: 'https://api.openstreetmap.org'
    },
    bikeAllowanceUrl: 'https://indemnitevelo.fr',
    widgetDefaultApiKey: '2190d7c6-3ef4-4bb7-ab76-779659185519',
    enableSimplifyCrossingInstructions: false,
    stripeApiKey: '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',
    wahoo: {
      clientId: 'JW6y_HNCuYk73Q2B3x_XAyD03BDObglIlEejxzC__PQ'
    }
  };
}
const defaultEnvironment = exports.defaultEnvironment = environment;